import completeContractIsNotAvailableDictionary from '@widgets/complete-contract-is-not-available/i18n/ru/complete-contract-is-not-available.dic.json';

export const completeContractIsNotAvailable = {
  COMPLETE_CONTRACT_IS_NOT_AVAILABLE: completeContractIsNotAvailableDictionary,
};

export const completeContractIsNotAvailableNamespaces = Object.keys(
  completeContractIsNotAvailable
);
